import { ref } from 'vue';

export const errors = ref<{ [key: string]: any[] }>({}); // Assuming errors can be of any type

export function getValidationErrorMessages(field: string): string[] {
  if (!errors.value) {
    return [];
  }
  const keys = Object.keys(errors.value);
  const key = keys
    .find((element) => element.toLowerCase() === field.toLowerCase())
    ?.toString();

  return key && errors.value[key] ? errors.value[key] : [];
}

export function getValidationErrors(field: string): string {
  const errorsArr = getValidationErrorMessages(field);
  if (errorsArr.length !== 0) {
    return errorsArr.join('\r\n');
  }
  return '';
}

export function hasValidationErrors(field: string): boolean {
  return getValidationErrorMessages(field).length !== 0;
}

export function setValidationErrors(payload: any): void {
  errors.value = payload;
}

export function resetErrors(): void {
  errors.value = {};
}
